class MFRTimelineSection {
  constructor(i, e, options) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      entry: ".timeline-section__entry",
      carousel: ".timeline-section",
      nav: ".timeline-section__nav",
      navButton: ".timeline-section__nav-button",
      title: ".timeline-section__entry-title",
    };

    this.options = options;

    this.init();
  }

  init() {
    this.$entry = this.$element.find(this.selectors.entry);
    this.$carousel = this.$element.find(this.selectors.carousel);
    this.$image = this.$element.find(this.selectors.image);

    this.initCarousel();
  }

  initCarousel() {
    this.$carousel.flickity({
      ...this.options,
      on: {
        ready: () => {
          this.initNav();
          this.updateHeights();
        },
        change: (index) => {
          this.setActiveButton(index);
        },
      },
    });
  }

  updateHeights() {
    // this.$entry.css({
    //     minHeight: "100%"
    // })
  }

  initNav() {
    this.$element.prepend($(this.generateNavHTML()));

    this.$navButton = this.$element.find(this.selectors.navButton);
    this.$navButton.on("click", (e) => {
      const index = $(e.currentTarget).data("index");

      this.$carousel.flickity("selectCell", index);
    });
  }

  setActiveButton(index) {
    const element = this.$element.find(
      `${this.selectors.navButton}[data-index="${index}"]`
    );
    this.$navButton.removeClass("is-active");
    element.addClass("is-active");
  }

  generateNavHTML() {
    const html = $(
      `<div class="${this.selectors.nav.replace(".", "")}"></div>`
    );

    this.$entry.each((i, e) => {
      html.append(`
                <div class="${this.selectors.navButton.replace(".", "")} ${
        i == 0 ? "is-active" : ""
      }"
                    data-index="${i}">
                    ${$(e).find(this.selectors.title).text()}
                </div>
            `);
    });

    return html;
  }
}